import React from "react";
import { withRouter } from "react-router-dom";

class ErrorBoundary extends React.Component {
  componentDidCatch(error, info) {
    this.props.history.push("/");
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(ErrorBoundary);
